import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SEOService } from '@box-core/services';
import { SeoOptions } from '@box-types';

@Component({
  selector: 'account-transparency-report',
  templateUrl: './account-transparency-report.page.html',
  styleUrls: ['./account-transparency-report.page.scss']
})
export class AccountTransparencyReportPage implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private seoService: SEOService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.setMetaTags();
  }
  private setMetaTags(): void {
    const options: SeoOptions = { title: this.activatedRoute.snapshot.data.breadcrumbName, url: this.router.url };
    this.seoService.setTags(options);
  }
}
